export const navItems = [
  { label: '首页', href: '#hero' },
  { label: '热门专题', href: '#index' },
  { label: '焦点深扒', href: '#carousel' },
  { label: '今日爆料', href: '#cards' },
  { label: '本站优势', href: '#features' },
  { label: '吃瓜视频', href: '#media' },
  { label: '瓜友热评', href: '#comments' },
];

export const heroData = {
  tag: '今日重磅 · 实时追踪',
  title: '黑料吃瓜网 · 你身边的吃瓜第一线',
  slogan: '每日大赛不重样，热榜大瓜一网打尽',
  description: '黑料吃瓜网每日大赛热榜，365天不间断追踪娱乐圈、网红圈、综艺圈最劲爆动态。从深夜爆料到清晨反转，从实锤证据到内幕深扒，我们用最快的速度、最全的角度，为你还原每一个大瓜的来龙去脉。最新黑料不打烊，吃瓜群众请坐稳，今天的瓜保甜。',
  stats: [
    { label: '每日更新', value: '24h不间断' },
    { label: '内容覆盖', value: '6大圈层' },
    { label: '吃瓜群众', value: '千万级热度' },
  ],
  primaryCta: { label: '立即吃瓜', href: '#cards' },
  secondaryCta: { label: '查看热榜', href: '#ranking' },
  image: 'https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20illustration%20of%20a%20vibrant%20newsroom%20with%20floating%20headlines%20and%20social%20media%20icons%2C%20warm%20coral%20and%20amber%20color%20palette%2C%20dynamic%20composition%20with%20layered%20geometric%20shapes%2C%20abstract%20data%20visualization%20elements%2C%20modern%20editorial%20design%20aesthetic%2C%20clean%20background%20with%20soft%20gradients%2C%20energetic%20and%20engaging%20visual%20style%2C%20no%20text%20in%20image&width=1200&height=900&seq=hero-main-2026&orientation=landscape',
};

export const cardsData = [
  {
    id: 'card-1',
    title: '某顶流深夜密会神秘女子，酒店同框照曝光',
    summary: '据知情人士透露，该顶流近期行程与公开信息存在多处矛盾，粉丝后援会连夜发布澄清声明但未获当事人回应。',
    tag: '娱乐圈',
    time: '2小时前',
    hot: '98万热度',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20cinematic%20night%20scene%20with%20silhouettes%20of%20two%20people%20near%20a%20luxury%20hotel%2C%20dramatic%20warm%20lighting%20with%20deep%20shadows%2C%20paparazzi%20style%20composition%2C%20coral%20and%20amber%20color%20tones%2C%20mysterious%20atmosphere%2C%20editorial%20photography%20style%2C%20clean%20minimal%20background%2C%20no%20visible%20faces&width=800&height=600&seq=card-news-01&orientation=landscape',
  },
  {
    id: 'card-2',
    title: '热门综艺录制现场爆发激烈冲突，导演组紧急叫停',
    summary: '现场观众爆料称两位常驻嘉宾因游戏环节判定产生分歧，场面一度失控。节目组尚未对此事作出正式回应。',
    tag: '综艺圈',
    time: '4小时前',
    hot: '76万热度',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20abstract%20illustration%20of%20a%20TV%20studio%20set%20with%20dramatic%20red%20and%20amber%20spotlights%2C%20two%20shadow%20figures%20facing%20each%20other%20in%20confrontation%2C%20dynamic%20tension%20composition%2C%20warm%20coral%20color%20palette%2C%20modern%20graphic%20design%20style%2C%20clean%20background&width=800&height=600&seq=card-news-02&orientation=landscape',
  },
  {
    id: 'card-3',
    title: '网红主播偷税漏税案最新进展：涉案金额或超九位数',
    summary: '税务部门确认已介入调查，涉及多个平台头部主播。业内人士分析此次专项整治行动将持续至年底。',
    tag: '网红圈',
    time: '6小时前',
    hot: '155万热度',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20conceptual%20image%20of%20a%20digital%20influencer%20studio%20with%20floating%20numbers%20and%20graphs%2C%20warm%20coral%20and%20amber%20abstract%20data%20visualization%2C%20modern%20minimalist%20composition%2C%20clean%20background%2C%20no%20human%20faces&width=800&height=600&seq=card-news-03&orientation=landscape',
  },
  {
    id: 'card-4',
    title: '某知名导演新片选角内幕曝光，带资进组成公开秘密',
    summary: '多位业内人士向本网证实，近期多部大制作影视剧存在选角不透明问题，引发行业内外广泛讨论。',
    tag: '影视圈',
    time: '8小时前',
    hot: '62万热度',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20cinematic%20film%20set%20illustration%20with%20director%20chair%20silhouette%20and%20spotlight%2C%20warm%20amber%20and%20coral%20lighting%2C%20dramatic%20shadows%2C%20editorial%20aesthetic%2C%20clean%20minimal%20composition%2C%20no%20text&width=800&height=600&seq=card-news-04&orientation=landscape',
  },
  {
    id: 'card-5',
    title: '说唱歌手新歌疑似diss多位同行，评论区火药味十足',
    summary: '歌曲发布仅3小时评论突破10万条，多位被影射对象已通过社交平台发布隐晦回应，网友纷纷加入解读大战。',
    tag: '音乐圈',
    time: '10小时前',
    hot: '89万热度',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20music%20studio%20scene%20with%20microphone%20and%20abstract%20sound%20waves%2C%20energetic%20warm%20red%20and%20amber%20tones%2C%20dynamic%20composition%2C%20modern%20graphic%20style%2C%20clean%20background%2C%20no%20people&width=800&height=600&seq=card-news-05&orientation=landscape',
  },
  {
    id: 'card-6',
    title: '体育明星代言翻车，品牌方连夜撤下所有物料',
    summary: '该运动员近期因个人行为引发巨大争议，多个合作品牌已单方面宣布解约，违约金数额引发业界关注。',
    tag: '体育圈',
    time: '12小时前',
    hot: '134万热度',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20sports%20arena%20illustration%20with%20abstract%20silhouette%20and%20falling%20sponsor%20logos%2C%20dramatic%20warm%20coral%20lighting%2C%20clean%20minimal%20composition%2C%20editorial%20style%2C%20no%20identifiable%20people&width=800&height=600&seq=card-news-06&orientation=landscape',
  },
];

export const updatesData = [
  { id: 'upd-1', time: '14:32', content: '某女星工作室发布律师函，否认与已婚商人的绯闻，称将追究造谣者法律责任', tag: '最新' },
  { id: 'upd-2', time: '13:15', content: '年度音乐盛典后台花絮流出，多位歌手之间的微妙互动引发粉丝脑补大戏', tag: '热' },
  { id: 'upd-3', time: '11:48', content: '知名编剧在社交平台发文暗讽同行，随后秒删，截图已被网友疯传', tag: '爆' },
  { id: 'upd-4', time: '10:02', content: '某综艺节目录制期间选手突然退赛，导师现场表情管理失败成最大看点', tag: '新' },
  { id: 'upd-5', time: '08:30', content: '短视频平台两大头部主播隔空互怼，双方粉丝已开启全网控评大战', tag: '热' },
  { id: 'upd-6', time: '昨日 22:15', content: '某影视公司内部邮件泄露，明年重点项目的演员阵容提前曝光引发热议', tag: '爆' },
  { id: 'upd-7', time: '昨日 19:40', content: '一线城市高端会所被曝为明星提供私密聚会服务，相关视频在网络流传', tag: '新' },
];

export const carouselData = [
  {
    id: 'car-1',
    title: '深度调查：娱乐圈「对赌协议」背后的资本游戏',
    summary: '从流量明星到顶流艺人，对赌协议如何绑架创作自由，又为何屡屡导致烂片频出？',
    tag: '深度调查',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20conceptual%20illustration%20of%20a%20spotlight%20shining%20on%20floating%20documents%20and%20contracts%2C%20warm%20coral%20and%20amber%20toned%2C%20editorial%20investigative%20journalism%20aesthetic%2C%20dramatic%20lighting%2C%20modern%20minimal%20composition&width=900&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    id: 'car-2',
    title: '网红经济泡沫：从月入千万到无人问津的坠落之路',
    summary: '复盘过去三年头部网红的兴衰轨迹，揭示流量变现模式背后的系统风险与人性考验。',
    tag: '行业分析',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20graph%20showing%20dramatic%20rise%20and%20fall%20with%20social%20media%20icons%2C%20warm%20amber%20and%20coral%20gradient%2C%20financial%20analysis%20aesthetic%2C%20clean%20minimal%20background%2C%20no%20text&width=900&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    id: 'car-3',
    title: '综艺剧本化：真人秀到底还有几分「真」？',
    summary: '前综艺编剧匿名爆料，揭秘真人秀节目从选角到冲突的完整剧本生产流水线。',
    tag: '独家揭秘',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20illustration%20of%20a%20TV%20control%20room%20with%20multiple%20screens%20showing%20abstract%20scenes%2C%20warm%20coral%20lighting%2C%20behind%20the%20scenes%20aesthetic%2C%20modern%20editorial%20style%2C%20clean%20composition&width=900&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    id: 'car-4',
    title: '粉丝经济2.0：从打榜应援到「偶像养成」的灰色产业链',
    summary: '深入探访粉头经济运作模式，揭示应援集资、数据造假与未成年消费的隐秘角落。',
    tag: '深度调查',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20abstract%20illustration%20of%20crowd%20silhouettes%20with%20glowing%20heart%20shapes%20and%20floating%20currency%20symbols%2C%20warm%20coral%20and%20amber%20palette%2C%20social%20commentary%20aesthetic%2C%20clean%20minimal%20style&width=900&height=600&seq=carousel-04&orientation=landscape',
  },
  {
    id: 'car-5',
    title: '音乐版权大战：一首热歌背后千万级别的利益博弈',
    summary: '从词曲作者到平台方，一首爆款歌曲的版权收益如何分配，为何纠纷不断？',
    tag: '行业揭秘',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20illustration%20of%20floating%20musical%20notes%20entangled%20with%20chains%20and%20locks%2C%20warm%20amber%20and%20coral%20tones%2C%20conceptual%20copyright%20theme%2C%20clean%20minimal%20composition%2C%20modern%20editorial%20style&width=900&height=600&seq=carousel-05&orientation=landscape',
  },
  {
    id: 'car-6',
    title: '短视频造星工厂：一个人设IP从孵化到变现的全过程',
    summary: '独家探访MCN机构内部运作，揭秘素人如何在三个月内被打造成百万粉丝网红。',
    tag: '独家探访',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20conveyor%20belt%20illustration%20with%20abstract%20human%20silhouettes%20transforming%20into%20shining%20stars%2C%20warm%20coral%20and%20amber%20gradient%2C%20modern%20industrial%20aesthetic%2C%20clean%20composition&width=900&height=600&seq=carousel-06&orientation=landscape',
  },
];

export const rankingData = [
  { rank: 1, title: '某顶流深夜密会神秘女子，酒店同框照曝光', heat: '980万', trend: 'up' },
  { rank: 2, title: '网红主播偷税漏税案涉案金额或超九位数', heat: '860万', trend: 'up' },
  { rank: 3, title: '体育明星代言翻车，品牌方连夜撤下所有物料', heat: '750万', trend: 'up' },
  { rank: 4, title: '热门综艺录制现场爆发激烈冲突导演组叫停', heat: '620万', trend: 'down' },
  { rank: 5, title: '说唱歌手新歌疑似diss多位同行引全网热议', heat: '510万', trend: 'up' },
  { rank: 6, title: '知名导演新片选角内幕曝光，带资进组成秘密', heat: '430万', trend: 'down' },
  { rank: 7, title: '年度音乐盛典后台花絮流出，歌手互动成焦点', heat: '380万', trend: 'new' },
];

export const faqData = [
  {
    id: 'faq-1',
    question: '黑料吃瓜网的内容来源是什么？如何保证真实性？',
    answer: '我们的内容来源于多渠道信息交叉验证，包括公开报道、社交平台一手信息、业内人士爆料以及用户投稿。每一条爆料发布前都经过至少双人交叉核实，标注信息来源等级，让吃瓜群众看得明白、吃得放心。对于无法完全核实的内容，会明确标注「传闻」标签。',
  },
  {
    id: 'faq-2',
    question: '每日大赛热榜是如何更新的？',
    answer: '热榜根据话题的全网讨论量、搜索热度、社交传播速度和用户互动数据综合计算，每小时自动刷新一次。重大突发事件会触发即时更新机制，确保你不错过任何一个大瓜。每日零点生成当日汇总战报。',
  },
  {
    id: 'faq-3',
    question: '如何向黑料吃瓜网投稿爆料？',
    answer: '你可以通过页面底部的联系投稿入口提交信息。我们承诺对投稿人信息严格保密，采用匿名化处理。爆料一经采纳将获得稿酬奖励，重大独家爆料更有丰厚奖金。投稿时请尽量提供可核实的证据材料。',
  },
  {
    id: 'faq-4',
    question: '黑料吃瓜网和其他娱乐资讯平台有什么不同？',
    answer: '我们不做简单搬运，坚持「深扒 + 追踪」的内容理念。每条爆料都配有完整的时间线、人物关系图和相关背景科普，让吃瓜不仅是看热闹，更能了解事情全貌。同时我们严格自律，不传播未经证实的恶意谣言，不参与网络暴力。',
  },
];

export const featuresData = [
  {
    id: 'feat-1',
    icon: 'ri-timer-flash-line',
    title: '极速追踪',
    description: '7×24小时全天候监控六大圈层动态，重大爆料5分钟内推送，比热搜快一步，让你的吃瓜永远领先朋友圈。',
  },
  {
    id: 'feat-2',
    icon: 'ri-stack-line',
    title: '深度深扒',
    description: '不只是表面爆料，每条大瓜配备完整的人物关系梳理、时间线复盘和背景知识科普，让你吃得明明白白。',
  },
  {
    id: 'feat-3',
    icon: 'ri-shield-check-line',
    title: '交叉验证',
    description: '多方信源交叉比对，标注信息可靠性等级。不传谣不信谣，做有态度的吃瓜群众集聚地。',
  },
];

export const commentsData = [
  {
    id: 'cmt-1',
    avatar: 'https://readdy.ai/api/search-image?query=A%20stylized%20minimalist%20avatar%20portrait%20of%20a%20young%20person%2C%20warm%20coral%20and%20amber%20tones%2C%20simple%20geometric%20background%2C%20modern%20flat%20illustration%20style%2C%20no%20text&width=120&height=120&seq=avatar-01&orientation=squarish',
    name: '吃瓜一线猹',
    time: '3小时前',
    content: '这个瓜我蹲了三天了，终于等到实锤！小编的时间线整理得太清楚了，建议大家都去看看完整深扒文章，比热搜上的碎片信息强一百倍。',
    likes: 2846,
  },
  {
    id: 'cmt-2',
    avatar: 'https://readdy.ai/api/search-image?query=A%20stylized%20minimalist%20avatar%20portrait%20in%20warm%20amber%20tones%2C%20simple%20geometric%20background%2C%20modern%20flat%20illustration%20style%2C%20no%20text&width=120&height=120&seq=avatar-02&orientation=squarish',
    name: '今天也在认真吃瓜',
    time: '5小时前',
    content: '每天上班第一件事就是打开黑料吃瓜网看看有没有新瓜，比看新闻联播还准时。热榜功能真的绝了，不会错过任何重点。',
    likes: 1523,
  },
  {
    id: 'cmt-3',
    avatar: 'https://readdy.ai/api/search-image?query=A%20stylized%20minimalist%20avatar%20portrait%20in%20warm%20coral%20tones%2C%20simple%20geometric%20background%2C%20modern%20flat%20illustration%20style%2C%20no%20text&width=120&height=120&seq=avatar-03&orientation=squarish',
    name: '理性吃瓜不站队',
    time: '8小时前',
    content: '说真的，这家是目前见过最专业的吃瓜平台了。每条爆料都有信源标注，不会为了流量乱带节奏。吃瓜也要讲基本法。',
    likes: 978,
  },
  {
    id: 'cmt-4',
    avatar: 'https://readdy.ai/api/search-image?query=A%20stylized%20minimalist%20avatar%20portrait%20in%20warm%20terracotta%20tones%2C%20simple%20geometric%20background%2C%20modern%20flat%20illustration%20style%2C%20no%20text&width=120&height=120&seq=avatar-04&orientation=squarish',
    name: '夜猫子吃瓜协会',
    time: '11小时前',
    content: '深夜档的瓜永远是最大的！自从关注了这里，我的夜生活丰富了许多。昨晚那个反转真的绝了，吃到我凌晨三点。',
    likes: 2105,
  },
];

export const aboutData = {
  title: '关于黑料吃瓜网',
  content: '黑料吃瓜网成立于2024年，是国内领先的娱乐八卦资讯聚合平台。我们秉承「最新黑料不打烊」的运营理念，以每日大赛热榜为核心产品，每日更新最新爆料和大瓜汇总，为千万吃瓜群众提供实时吃瓜热榜服务。\n\n我们的编辑团队由资深娱乐记者、前综艺编剧和数据挖掘工程师组成，采用多渠道信息交叉验证机制，确保每一条爆料都有据可查。从娱乐圈到网红圈，从综艺圈到体育圈，六大圈层全覆盖，让你一站式掌握当天最劲爆话题。\n\n吃瓜不是看热闹，是一种参与时代的方式。黑料吃瓜网，让每一次吃瓜都有价值。',
  image: 'https://readdy.ai/api/search-image?query=A%20stylized%20modern%20newsroom%20workspace%20with%20multiple%20screens%20displaying%20abstract%20data%2C%20warm%20coral%20and%20amber%20ambient%20lighting%2C%20collaborative%20team%20energy%2C%20clean%20minimalist%20office%20aesthetic%2C%20professional%20yet%20creative%20atmosphere&width=800&height=500&seq=about-brand&orientation=landscape',
};

export const appData = {
  title: '随时随地，吃瓜不停',
  description: '黑料吃瓜网移动端适配完美，无论你是在地铁通勤、午休摸鱼还是深夜修仙，打开手机浏览器即可畅享完整吃瓜体验。重大爆料推送不延迟，热榜实时更新不卡顿，吃瓜体验丝滑流畅。',
  features: ['实时推送', '夜间模式', '一键分享', '收藏专题'],
  image: 'https://readdy.ai/api/search-image?query=A%20stylized%20smartphone%20mockup%20showing%20a%20modern%20news%20app%20interface%20with%20warm%20coral%20and%20amber%20color%20scheme%2C%20clean%20minimalist%20UI%20design%2C%20card%20based%20layout%2C%20floating%20on%20a%20soft%20gradient%20background&width=600&height=900&seq=app-mockup&orientation=portrait',
};

export const mediaData = [
  {
    id: 'med-1',
    title: '本周吃瓜大盘点：五大最劲爆事件全程回顾',
    duration: '15:42',
    views: '128万',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20video%20thumbnail%20illustration%20with%20play%20button%20overlay%2C%20collage%20of%20abstract%20news%20elements%2C%20warm%20coral%20and%20amber%20tones%2C%20YouTube%20style%20composition%2C%20clean%20background&width=800&height=500&seq=media-01&orientation=landscape',
  },
  {
    id: 'med-2',
    title: '深度解析：网红经济背后的资本操盘手',
    duration: '22:08',
    views: '96万',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20video%20thumbnail%20with%20abstract%20financial%20charts%20and%20social%20media%20icons%2C%20warm%20amber%20lighting%2C%20documentary%20style%20composition%2C%20clean%20minimal%20background&width=800&height=500&seq=media-02&orientation=landscape',
  },
  {
    id: 'med-3',
    title: '娱乐圈「阴阳合同」前世今生全揭秘',
    duration: '18:35',
    views: '203万',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20video%20thumbnail%20showing%20two%20overlapping%20documents%20with%20dramatic%20contrast%2C%20warm%20coral%20and%20dark%20tones%2C%20investigative%20journalism%20aesthetic%2C%20clean%20minimal%20style&width=800&height=500&seq=media-03&orientation=landscape',
  },
  {
    id: 'med-4',
    title: '粉丝亲述：我在粉圈卧底的180天',
    duration: '30:15',
    views: '315万',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20video%20thumbnail%20with%20silhouette%20figure%20behind%20translucent%20screen%2C%20mysterious%20atmosphere%2C%20warm%20coral%20and%20amber%20tones%2C%20undercover%20documentary%20style%2C%20clean%20composition&width=800&height=500&seq=media-04&orientation=landscape',
  },
];

export const topicsData = [
  { id: 'top-1', name: '顶流恋情', count: '126条', hot: true },
  { id: 'top-2', name: '综艺翻车', count: '89条', hot: true },
  { id: 'top-3', name: '网红塌房', count: '203条', hot: true },
  { id: 'top-4', name: '明星税务', count: '67条', hot: false },
  { id: 'top-5', name: '影视选角', count: '54条', hot: false },
  { id: 'top-6', name: '音乐diss', count: '78条', hot: false },
  { id: 'top-7', name: '体育代言', count: '45条', hot: false },
  { id: 'top-8', name: '直播带货', count: '112条', hot: false },
  { id: 'top-9', name: '资本对赌', count: '38条', hot: false },
];

export const contactData = {
  title: '爆料投稿 / 商务合作',
  description: '有独家猛料？想成为我们的特约爆料人？或是有商务合作意向？欢迎通过以下方式联系我们。我们对投稿人信息严格保密，重大独家爆料一经采纳，稿酬丰厚。',
  email: 'tips@heimailiao.com',
  wechat: 'heimailiao_tips',
  tips: '投稿请尽量包含时间、地点、人物、事件经过，并附上可核实的证据材料（照片、截图、录音等）。匿名投稿同样欢迎，但提供证据的稿件采纳率更高。',
};

export const indexData = [
  {
    id: 'idx-1',
    title: '2026年度娱乐圈十大未解之谜',
    summary: '从年初的跨国恋情传闻到近期的高层震动，盘点今年最扑朔迷离的十大悬案。',
    count: '18篇',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20mystery%20themed%20illustration%20with%20question%20marks%20and%20spotlights%2C%20warm%20coral%20and%20amber%20tones%2C%20editorial%20aesthetic%2C%20clean%20minimal%20composition&width=600&height=400&seq=index-01&orientation=landscape',
  },
  {
    id: 'idx-2',
    title: '网红圈大地震：2026塌房全记录',
    summary: '从千万粉大V到新晋顶流，这一年倒下的网红比你想象的多得多。',
    count: '25篇',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20falling%20dominoes%20illustration%20with%20social%20media%20icons%2C%20warm%20amber%20and%20coral%20dramatic%20lighting%2C%20clean%20minimal%20composition&width=600&height=400&seq=index-02&orientation=landscape',
  },
  {
    id: 'idx-3',
    title: '综艺剧本揭秘：那些你不知道的录制内幕',
    summary: '前综艺人匿名爆料，从选角到剪辑，每个环节都有你看不到的「设计」。',
    count: '12篇',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20behind%20the%20scenes%20illustration%20of%20a%20TV%20studio%2C%20warm%20coral%20lighting%2C%20hidden%20camera%20aesthetic%2C%20clean%20minimal%20style&width=600&height=400&seq=index-03&orientation=landscape',
  },
  {
    id: 'idx-4',
    title: '粉丝经济深度调查系列',
    summary: '从打榜到应援，从集资到控评，揭开粉丝经济背后庞大的利益链条。',
    count: '9篇',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20crowd%20of%20abstract%20glowing%20hearts%20forming%20a%20chain%2C%20warm%20coral%20and%20amber%20gradient%2C%20clean%20minimal%20composition&width=600&height=400&seq=index-04&orientation=landscape',
  },
  {
    id: 'idx-5',
    title: '音乐圈版权大战全程追踪',
    summary: '一首热歌引发的亿元级版权纠纷，我们持续追踪事件全貌。',
    count: '7篇',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20illustration%20of%20musical%20notes%20locked%20in%20chains%2C%20warm%20amber%20and%20coral%20conceptual%20art%2C%20clean%20minimal%20background&width=600&height=400&seq=index-05&orientation=landscape',
  },
  {
    id: 'idx-6',
    title: 'MCN机构内幕大起底',
    summary: '短视频造星流水线全揭秘：素人如何被包装、运营、变现与抛弃。',
    count: '14篇',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20factory%20conveyor%20belt%20with%20abstract%20star%20shapes%2C%20warm%20coral%20industrial%20aesthetic%2C%20clean%20minimal%20composition&width=600&height=400&seq=index-06&orientation=landscape',
  },
  {
    id: 'idx-7',
    title: '知名导演访谈系列：圈内人讲圈内事',
    summary: '多位不愿具名的导演和制片人，为你讲述娱乐圈最真实的一面。',
    count: '6篇',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20silhouette%20interview%20scene%20with%20dramatic%20lighting%2C%20warm%20coral%20and%20amber%20tones%2C%20anonymous%20source%20aesthetic%2C%20clean%20composition&width=600&height=400&seq=index-07&orientation=landscape',
  },
  {
    id: 'idx-8',
    title: '体育圈代言翻车事件汇编',
    summary: '从个人丑闻到商业违约，体育明星代言风险比你想象的更高。',
    count: '11篇',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20sports%20trophy%20falling%20apart%20illustration%2C%20warm%20amber%20and%20coral%20dramatic%20lighting%2C%20clean%20minimal%20composition&width=600&height=400&seq=index-08&orientation=landscape',
  },
  {
    id: 'idx-9',
    title: '直播带货假货风波系列调查',
    summary: '头部主播直播间售假疑云，我们跟踪调查了供应链的每一个环节。',
    count: '16篇',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20magnifying%20glass%20over%20shopping%20cart%20illustration%2C%20warm%20coral%20investigative%20aesthetic%2C%20clean%20minimal%20composition&width=600&height=400&seq=index-09&orientation=landscape',
  },
];

export const footerData = {
  description: '黑料吃瓜网 — 每日大赛热榜，每日更新最新爆料、大瓜汇总。实时吃瓜热榜，最新黑料不打烊。做最有态度的吃瓜群众集聚地。',
  quickLinks: [
    { label: '今日爆料', href: '#cards' },
    { label: '实时快讯', href: '#updates' },
    { label: '焦点深扒', href: '#carousel' },
    { label: '热度榜单', href: '#ranking' },
  ],
  serviceLinks: [
    { label: '常见问题', href: '#faq' },
    { label: '关于我们', href: '#about' },
    { label: '联系投稿', href: '#contact' },
    { label: '热门专题', href: '#index' },
  ],
  partners: '合作伙伴',
};